import React from "react";
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  ArcElement,
  type LayoutPosition,
  type TooltipItem,
} from "chart.js";
import { Doughnut } from "react-chartjs-2";
import type { ChartDataSet } from "./getChartConfig";

function sum(array: number[]) {
  if (!array) {
    return 0;
  }
  return array.reduce((acc, curr) => {
    return acc + curr;
  }, 0);
}

const labelTooltip = (tooltipData: TooltipItem<"doughnut">): string => {
  return `${tooltipData.label.trim()}: ${
    tooltipData.formattedValue || 0
  } Patients`;
};

const doughnutOptions = {
  cutout: "75%",
  centerText: true,
  maintainAspectRatio: true,
  responsive: true,
  plugins: {
    legend: {
      display: true,
      onClick: undefined,
      position: "right" as LayoutPosition,
      maxWidth: window.innerWidth > 1200 ? 260 : 300,
      labels: {
        padding: 15,
        usePointStyle: true,
        pointStyle: "circle",
      },
    },
    tooltip: {
      callbacks: {
        label: labelTooltip,
      },
    },
  },
};

const centerText = {
  id: "centerText",
  afterDatasetsDraw(chart: ChartJS<"doughnut">) {
    const totalAmount = sum(chart.data.datasets[0].data);
    const {
      ctx,
      chartArea: { top, width, height },
    } = chart;

    const textSize = 22;
    const textSpace = 13;
    ctx.save();
    ctx.font = `bold ${textSize * 0.53}px DM Sans`;
    ctx.fillStyle = "#64748B";
    ctx.textAlign = "center";
    ctx.fillText("Total", width / 2, height / 2 + top - textSpace);
    ctx.restore();

    ctx.font = `${textSize}px DM Sans`;
    ctx.fillStyle = "#334155";
    ctx.textAlign = "center";
    ctx.fillText(
      totalAmount.toString(),
      width / 2,
      height / 2 + top + textSpace,
    );
    ctx.restore();
  },
};

ChartJS.register(ArcElement, Tooltip, Legend);

export default function DoughnutPMI({ data }: { data: ChartDataSet }) {
  return (
    <Doughnut
      data={data}
      options={doughnutOptions}
      plugins={[centerText]}
      style={{ minHeight: 150, maxHeight: 250 }}
    />
  );
}
